import { render, staticRenderFns } from "./SpaceSettingsExport.vue?vue&type=template&id=5b1608b6&"
import script from "./SpaceSettingsExport.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports